import React from "react"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import { aemAxiosInstance } from "@/constants/api"
import { i18n } from "next-i18next"
import { CHANGE_PASSWORD_MODEL_DATA_URL } from "@/constants/routes"
import { headerUrl, footerUrl } from "@/constants/"
import { filterBackEndJson } from "@/utils/helper"

import GlobalPageHeader from "@/components/Shared/GlobalPage/GlobalPageHeader"
import GlobalPageFooter from "@/components/Shared/GlobalPage/GlobalPageFooter"
import GlobalPageLayout from "@/components/Shared/GlobalPage/GlobalPageLayout"
import AemGrid from "@/components/AemGrid"
import ChangePassword from "@/components/ChangePassword"

const ChangePasswordPage = props => {
  const {
    tmpData: data,
    headertmp: header,
    footertmp: footer,
    globalScript,
    footerScript,
    analysticsScript,
  } = props

  return (
    <GlobalPageLayout
      header={
        <GlobalPageHeader
          header={header}
          globalScripting={globalScript}
          analysticsScript={analysticsScript}
        />
      }
      footer={<GlobalPageFooter footer={footer} footerScripting={footerScript} />}
    >
      <AemGrid
        data={data}
        count={0}
        changePassword={data => <ChangePassword data={data} />}
      />
    </GlobalPageLayout>
  )
}

/**
 * Get ServerSideProps together.
 * @param {Object} request The first number.
 * @return {object} The props.
 */
export async function getServerSideProps({ req, locale }) {
  await i18n?.reloadResources()
  const urlPath = req.url.split("?")[0]

  const { data } = await aemAxiosInstance({
    url: CHANGE_PASSWORD_MODEL_DATA_URL,
    method: "GET",
  })

  const { data: headerData } = await aemAxiosInstance({
    url: `${data.headerExpFrg ? data.headerExpFrg : headerUrl}.model.json`,
    method: "GET",
  })

  const { data: footerData } = await aemAxiosInstance({
    url: `${data.footerExpFrg ? data.footerExpFrg : footerUrl}.model.json`,
    method: "GET",
  })

  const globalScript = data?.globalScript ? data.globalScript : null
  const analyticsScriptClass = data?.analyticsScriptClass
    ? data?.analyticsScriptClass
    : null

  let tmpData = {}
  if (data.pageComponentProperties) {
    tmpData = data.pageComponentProperties
  } else {
    tmpData = data
  }
  tmpData = filterBackEndJson(tmpData)
  const headertmp = filterBackEndJson(headerData)
  const footertmp = filterBackEndJson(footerData)
  const metaContent = data?.metaContent ?? ""
  return {
    props: {
      tmpData,
      headertmp,
      footertmp,
      globalScript,
      analyticsScriptClass,
      urlPath,
      metaContent,
      ...(await serverSideTranslations(locale, ["common"])),
    },
  }
}

export default ChangePasswordPage
